import { render, staticRenderFns } from "./dados-reajuste.vue?vue&type=template&id=424f1e8a&scoped=true"
import script from "./dados-reajuste.vue?vue&type=script&lang=js"
export * from "./dados-reajuste.vue?vue&type=script&lang=js"
import style0 from "./dados-reajuste.vue?vue&type=style&index=0&id=424f1e8a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "424f1e8a",
  null
  
)

export default component.exports